import CompleteVerificationModal from './CompleteVerificationModal';

export default CompleteVerificationModal;
